import Http from '../http';

class ZoneService {
  // Fetch all zones
  static async getAllZones() {
    return Http.get('/zones');
  }

  // Fetch a single zone by ID
  static async getZoneById(id) {
    return Http.get(`/zones/${id}`);
  }

  // Add a new zone
  static async addZone(data) {
    console.log("Adding Zone:", data);
    return Http.post('/zones', data);
  }

  // Update an existing zone by ID
  static async updateZone(id, data) {
    console.log("Updating Zone:", data);
    return Http.update(`/zones/${id}`, data);
  }

  // Delete a zone by ID
  static async deleteZone(id) {
    return Http.delete(`/zones/${id}`);
  }
}

export default ZoneService;
